import { createSlice } from '@reduxjs/toolkit';
// utils

import { SERVER_API } from '../../config-global';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  events: [],
  events2: [],
  eventDetails: null,
  eventDetails2: null,
  summary: null,
  locationDetail: [],
  target: [],
  GenerateByMonth:[],
};

const slice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET EVENTS
    getUser_SelectAllEventIntoEventListTableSuccess(state, action) {
      state.isLoading = false;
      state.events = action.payload;
    },

    getUser_SelectAllEventIntoEventListTableSuccess2(state, action) {
      state.isLoading = false;
      state.events2 = action.payload;
    },

    getAdmin_SelectEventIntoCEFSuccess(state, action) {
      state.isLoading = false;
      state.eventDetails = action.payload;
    },
    getAdmin_SelectEventIntoCEFSuccess2(state, action) {
      state.isLoading = false;
      state.eventDetails2 = action.payload;
    },
    Admin_UpdateCEFSectionASuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionA = action.payload;
    },
    Admin_UpdateCEFSectionBSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionB = action.payload;
    },
    Admin_UpdateCEFSectionCSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionC = action.payload;
    },
    Admin_UpdateCEFSectionDSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionD = action.payload;
    },
    Admin_UpdateCEFSectionESuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionE = action.payload;
    },
    Admin_UpdateCEFSectionFSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionF = action.payload;
    },
    Admin_UpdateCEFSectionHSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionH = action.payload;
    },
    Admin_UpdateCEFSectionISuccess(state, action) {
      state.isLoading = false;
      state.eventDetailSectionI = action.payload;
    },

    Admin_UpdateCEFAcknowledgementSuccess(state, action) {
      state.isLoading = false;
      state.Acknowledgement = action.payload;
    },

    Admin_UpdateCEFChecklistSuccess(state, action) {
      state.isLoading = false;
      state.CheckList = action.payload;
    },

    Admin_DeleteEventByEventIDSuccess(state, action) {
      state.isLoading = false;
      state.CheckList = action.payload;
    },
    getAdminDashboard_GroupByLocationSuccess(state, action) {
      state.isLoading = false;
      state.location = action.payload;
    },
    getAdminDashboard_SelectedRegionDetailSuccess(state, action) {
      state.isLoading = false;
      state.locationDetail = action.payload;
    },
    getAdminDashboard_FourDifferenceDataSuccess(state, action) {
      state.isLoading = false;
      state.fourData = action.payload;
    },

    getAdminDashboard_ImportantEventCountSuccess(state, action) {
      state.isLoading = false;
      state.ImportantEventCount = action.payload;
    },

    General_SelectPillarsSuccess(state, action) {
      state.isLoading = false;
      state.pillars = action.payload;
    },
    Admin_UpdateEventByExcelSuccess(state, action) {
      state.isLoading = false;
      state.eventDetailExcel = action.payload;
    },

    getAUser_SelectGeneralScoreByEventIDSuccess(state, action) {
      state.isLoading = false;
      state.EventGeneralScore = action.payload;
    },
    AdminDashboard_AIAssistBox_GenerateSummaryByMonthSuccess(state, action) {
      state.isLoading = false;
      state.GenerateByMonth = action.payload;
    },

    // CLEAR ERROR
    clearError(state) {
      state.error = null;
    },

    // CLEAR EVENT DETAILS
    clearEventDetails(state, action) {
      state.eventDetails = null;
    },

    getSummarySuccess(state, action) {
      state.isLoading = false;
      state.summary = action.payload;
    },

    AdminDashboard_Select_UNSDG_TargetSuccess(state, action) {
      state.isLoading = false;
      state.target = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { clearError, clearEventDetails } = slice.actions;

// ----------------------------------------------------------------------

export function AdminDashboard_ImportantEventCount() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_ImportantEventCount`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getAdminDashboard_ImportantEventCountSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_FourDifferenceData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_FourDifferenceData`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getAdminDashboard_FourDifferenceDataSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_SelectedRegionDetail() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_SelectedRegionDetail`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getAdminDashboard_SelectedRegionDetailSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_GroupByLocation() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_GroupByLocation`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getAdminDashboard_GroupByLocationSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function User_SelectAllEventIntoEventListTable() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}User_SelectAllEventIntoEventListTable`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getUser_SelectAllEventIntoEventListTableSuccess(
              JSON.parse(data.ReturnData)
            )
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function User_SelectAllEventIntoEventListTable2() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}User_SelectAllEventIntoEventListTable2`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.getUser_SelectAllEventIntoEventListTableSuccess2(
              JSON.parse(data.ReturnData)
            )
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_SelectEventIntoCEF(eventID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${SERVER_API}Admin_SelectEventIntoCEF?eventID=${encodeURIComponent(eventID)}`
      );
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          const eventData = JSON.parse(data.ReturnData)[0];
          dispatch(slice.actions.getAdmin_SelectEventIntoCEFSuccess(eventData));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_SelectEventIntoCEF2(eventID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${SERVER_API}Admin_SelectEventIntoCEF2?eventID=${encodeURIComponent(eventID)}`
      );
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          const eventData = JSON.parse(data.ReturnData)[0];
          dispatch(slice.actions.getAdmin_SelectEventIntoCEFSuccess2(eventData));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionA(updateData, InsertedID, userID) {
  console.log('Admin_UpdateCEFSectionA', userID);
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl = `${SERVER_API}Admin_UpdateCEFSectionA?applicantName=${encodeURIComponent(
        updateData.applicantName
      )}&prefix=${encodeURIComponent(updateData.prefix)}&designation=${encodeURIComponent(
        updateData.designation
      )}&organisationName=${encodeURIComponent(
        updateData.organisationName
      )}&registeredOrganisationAddress=${encodeURIComponent(
        updateData.registeredOrganisationAddress
      )}&mailingAddress=${encodeURIComponent(
        updateData.mailingAddress
      )}&organisationTelephone=${encodeURIComponent(
        updateData.organisationTelephone
      )}&organisationFax=${encodeURIComponent(
        updateData.organisationFax
      )}&organisationMobileNo=${encodeURIComponent(
        updateData.organisationMobileNo
      )}&organisationEmail=${encodeURIComponent(
        updateData.organisationEmail
      )}&organisationSocialMediaAccount=${encodeURIComponent(
        updateData.organisationSocialMediaAccount
      )}&organisationWebsite=${encodeURIComponent(
        updateData.organisationWebsite
      )}&authorisedProfile=${encodeURIComponent(
        updateData.authorisedProfile
      )}&organisationProfile=${encodeURIComponent(
        updateData.organisationProfile
      )}&InsertedID=${InsertedID}
        &userID=${userID}
      `;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionASuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionB(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionB?` +
        `affiliatedOrganisationName=${encodeURIComponent(updateData.affiliatedOrganisationName)}&` +
        `affiliatedContactPerson=${encodeURIComponent(updateData.affiliatedContactPerson)}&` +
        `affiliatedPosition=${encodeURIComponent(updateData.affiliatedPosition)}&` +
        `affiliatedAddress=${encodeURIComponent(updateData.affiliatedAddress)}&` +
        `affiliatedTelephone=${encodeURIComponent(updateData.affiliatedTelephone)}&` +
        `affiliatedFax=${encodeURIComponent(updateData.affiliatedFax)}&` +
        `affiliatedEmail=${encodeURIComponent(updateData.affiliatedEmail)}&` +
        `affiliatedWebsite=${encodeURIComponent(updateData.affiliatedWebsite)}&` +
        `InsertedID=${InsertedID}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionBSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionC(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionC?` +
        `InsertedID=${InsertedID}&` +
        `topic=${encodeURIComponent(updateData.topic)}&` +
        `category=${encodeURIComponent(updateData.category)}&` +
        `type=${encodeURIComponent(updateData.type)}&` +
        `edition=${encodeURIComponent(updateData.edition)}&` +
        `segment=${encodeURIComponent(updateData.segment)}&` +
        `frequency=${encodeURIComponent(updateData.frequency)}&` +
        `pattern=${encodeURIComponent(updateData.pattern)}&` +
        `format=${encodeURIComponent(updateData.format)}&` +
        `eventName=${encodeURIComponent(updateData.eventName)}&` +
        `eventAcronym=${encodeURIComponent(updateData.eventAcronym)}&` +
        `supportingAgency=${encodeURIComponent(updateData.supportingAgency)}&` +
        `startDate=${encodeURIComponent(updateData.startDate)}&` +
        `endDate=${encodeURIComponent(updateData.endDate)}&` +
        `duration=${encodeURIComponent(updateData.duration)}&` +
        `location=${encodeURIComponent(updateData.location)}&` +
        `venue=${encodeURIComponent(updateData.venue)}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionCSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionD(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionD?` +
        `InsertedID=${encodeURIComponent(InsertedID)}` +
        `&exhSarawak=${encodeURIComponent(updateData.exhSarawak)}` +
        `&exhROM=${encodeURIComponent(updateData.exhROM)}` +
        `&exhInternational=${encodeURIComponent(updateData.exhInternational)}` +
        `&exhTotal=${encodeURIComponent(updateData.exhTotal)}` +
        `&attendeeCategories=${encodeURIComponent(updateData.attendeeCategories)}` + // Use encodeURIComponent for strings
        `&Scategory=${encodeURIComponent(updateData.Scategory)}` + // Assuming Scategory is a string
        `&fee=${encodeURIComponent(updateData.fee)}` + // Assuming fee is a number
        `&teiTotal=${encodeURIComponent(updateData.teiTotal)}` +
        `&teiDDE=${encodeURIComponent(updateData.teiDDE)}` +
        `&teiTaxRev=${encodeURIComponent(updateData.teiTaxRev)}` +
        `&teiEmpOpp=${encodeURIComponent(updateData.teiEmpOpp)}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionDSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionE(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionE?` +
        `summary=${encodeURIComponent(updateData.summary)}` +
        `&aimsAndObjectives=${encodeURIComponent(updateData.aimsAndObjectives)}` +
        `&knowledgeExpansion=${encodeURIComponent(updateData.knowledgeExpansion)}` +
        `&raisingAwareness=${encodeURIComponent(updateData.raisingAwareness)}` +
        `&fundraising=${encodeURIComponent(updateData.fundraising)}` +
        `&futureOpportunity=${encodeURIComponent(updateData.futureOpportunity)}` +
        `&networkCollaboration=${encodeURIComponent(updateData.networkCollaboration)}` +
        `&educationOutcome=${encodeURIComponent(updateData.educationOutcome)}` +
        `&sponsorShip=${encodeURIComponent(updateData.sponsorShip)}` +
        `&historyEvent1Date=${encodeURIComponent(updateData.historyEvent1Date)}` +
        `&historyEvent1City=${encodeURIComponent(updateData.historyEvent1City)}` +
        `&historyEvent1DelNo=${encodeURIComponent(updateData.historyEvent1DelNo)}` +
        `&historyEvent1RegFee=${encodeURIComponent(updateData.historyEvent1RegFee)}` +
        `&historyEvent2Date=${encodeURIComponent(updateData.historyEvent2Date)}` +
        `&historyEvent2City=${encodeURIComponent(updateData.historyEvent2City)}` +
        `&historyEvent2DelNo=${encodeURIComponent(updateData.historyEvent2DelNo)}` +
        `&historyEvent2RegFee=${encodeURIComponent(updateData.historyEvent2RegFee)}` +
        `&InsertedID=${InsertedID}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionESuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionF(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionF?` +
        `InsertedID=${InsertedID}&` +
        `bidProDesFactorBidSubmission=${updateData.bidProDesFactorBidSubmission}&` +
        `bidProDesFactorComDecision=${updateData.bidProDesFactorComDecision}&` +
        `bidProDesFactorIndividual=${updateData.bidProDesFactorIndividual}&` +
        `bidProDesFactorAutoSwk=${updateData.bidProDesFactorAutoSwk}&` +
        `bidProDesFactorRotation=${updateData.bidProDesFactorRotation}&` +
        `bidProDesFactorVoteDel=${updateData.bidProDesFactorVoteDel}&` +
        `bidProDesFactorOthers=${encodeURIComponent(updateData.bidProDesFactorOthers)}&` +
        `bidProHosted=${updateData.bidProHosted}&` +
        `bidProHostedDate=${encodeURIComponent(updateData.bidProHostedDate)}&` +
        `bidProHostedOthMys=${updateData.bidProHostedOthMys}&` +
        `bidProHostedOthMysDate=${encodeURIComponent(updateData.bidProHostedOthMysDate)}&` +
        `bidProCompetitor=${encodeURIComponent(updateData.bidProCompetitor)}&` +
        `subsidybreakEven=${encodeURIComponent(updateData.subsidybreakEven)}&` +
        `generateReturn=${encodeURIComponent(updateData.generateReturn)}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionFSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionI(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionI?` +
        `InsertedID=${InsertedID}&` +
        `eventsAimsAndObjectives=${encodeURIComponent(updateData.eventsAimsAndObjectives)}&` +
        `serviceAcquired1=${encodeURIComponent(updateData.serviceAcquired1)}&` +
        `capabilitiesAndExperience1=${encodeURIComponent(updateData.capabilitiesAndExperience1)}&` +
        `contactPerson1=${encodeURIComponent(updateData.contactPerson1)}&` +
        `companyName1=${encodeURIComponent(updateData.companyName1)}&` +
        `registrationNumber1=${encodeURIComponent(updateData.registrationNumber1)}&` +
        `officeAddress1=${encodeURIComponent(updateData.officeAddress1)}&` +
        `contactTelephoneNum1=${encodeURIComponent(updateData.contactTelephoneNum1)}&` +
        `contactFacsimile1=${encodeURIComponent(updateData.contactFacsimile1)}&` +
        `contactEmail1=${encodeURIComponent(updateData.contactEmail1)}&` +
        `contactWebsite1=${encodeURIComponent(updateData.contactWebsite1)}&` +
        `serviceEngaged1=${encodeURIComponent(updateData.serviceEngaged1)}&` +
        `serviceAcquired2=${encodeURIComponent(updateData.serviceAcquired2)}&` +
        `capabilitiesAndExperience2=${encodeURIComponent(updateData.capabilitiesAndExperience2)}&` +
        `contactPerson2=${encodeURIComponent(updateData.contactPerson2)}&` +
        `companyName2=${encodeURIComponent(updateData.companyName2)}&` +
        `registrationNumber2=${encodeURIComponent(updateData.registrationNumber2)}&` +
        `officeAddress2=${encodeURIComponent(updateData.officeAddress2)}&` +
        `contactTelephoneNum2=${encodeURIComponent(updateData.contactTelephoneNum2)}&` +
        `contactFacsimile2=${encodeURIComponent(updateData.contactFacsimile2)}&` +
        `contactEmail2=${encodeURIComponent(updateData.contactEmail2)}&` +
        `contactWebsite2=${encodeURIComponent(updateData.contactWebsite2)}&` +
        `serviceEngaged2=${encodeURIComponent(updateData.serviceEngaged2)}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionISuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionH(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionH?` +
        `InsertedID=${InsertedID}&` +
        `amountRequested=${encodeURIComponent(updateData.amountRequested)}&` +
        `amountRequestedOfficeNote=${encodeURIComponent(updateData.amountRequestedOfficeNote)}&` +
        `subsidyPerDelegate=${encodeURIComponent(updateData.subsidyPerDelegate)}&` +
        `subsidyPerDelegateOfficeNote=${encodeURIComponent(
          updateData.subsidyPerDelegateOfficeNote
        )}&` +
        `deadlineForDecision=${encodeURIComponent(updateData.deadlineForDecision)}&` +
        `year1Amount=${encodeURIComponent(updateData.year1Amount)}&` +
        `year2Amount=${encodeURIComponent(updateData.year2Amount)}&` +
        `year3Amount=${encodeURIComponent(updateData.year3Amount)}&` +
        `year4Amount=${encodeURIComponent(updateData.year4Amount)}&` +
        `year5Amount=${encodeURIComponent(updateData.year5Amount)}&` +
        `biddingSupportyear1=${encodeURIComponent(updateData.biddingSupport1)}&` +
        `biddingSupportyear2=${encodeURIComponent(updateData.biddingSupport2)}&` +
        `biddingSupportyear3=${encodeURIComponent(updateData.biddingSupport3)}&` +
        `biddingSupportyear4=${encodeURIComponent(updateData.biddingSupport4)}&` +
        `biddingSupportyear5=${encodeURIComponent(updateData.biddingSupport5)}&` +
        `biddingSupportyeartotal=${encodeURIComponent(updateData.biddingSupporttotal)}&` +
        `siteInspection1=${encodeURIComponent(updateData.siteInspection1)}&` +
        `siteInspection2=${encodeURIComponent(updateData.siteInspection2)}&` +
        `siteInspection3=${encodeURIComponent(updateData.siteInspection3)}&` +
        `siteInspection4=${encodeURIComponent(updateData.siteInspection4)}&` +
        `siteInspection5=${encodeURIComponent(updateData.siteInspection5)}&` +
        `siteInspectiontotal=${encodeURIComponent(updateData.siteInspectiontotal)}&` +
        `promotionalMarketingMaterial1=${encodeURIComponent(
          updateData.promotionalMarketingMaterial1
        )}&` +
        `promotionalMarketingMaterial2=${encodeURIComponent(
          updateData.promotionalMarketingMaterial2
        )}&` +
        `promotionalMarketingMaterial3=${encodeURIComponent(
          updateData.promotionalMarketingMaterial3
        )}&` +
        `promotionalMarketingMaterial4=${encodeURIComponent(
          updateData.promotionalMarketingMaterial4
        )}&` +
        `promotionalMarketingMaterial5=${encodeURIComponent(
          updateData.promotionalMarketingMaterial5
        )}&` +
        `promotionalMarketingMaterialtotal=${encodeURIComponent(
          updateData.promotionalMarketingMaterialtotal
        )}&` +
        `marketingGimmick1=${encodeURIComponent(updateData.marketingGimmick1)}&` +
        `marketingGimmick2=${encodeURIComponent(updateData.marketingGimmick2)}&` +
        `marketingGimmick3=${encodeURIComponent(updateData.marketingGimmick3)}&` +
        `marketingGimmick4=${encodeURIComponent(updateData.marketingGimmick4)}&` +
        `marketingGimmick5=${encodeURIComponent(updateData.marketingGimmick5)}&` +
        `marketingGimmicktotal=${encodeURIComponent(updateData.marketingGimmicktotal)}&` +
        `eventDigitalisation1=${encodeURIComponent(updateData.eventDigitalisation1)}&` +
        `eventDigitalisation2=${encodeURIComponent(updateData.eventDigitalisation2)}&` +
        `eventDigitalisation3=${encodeURIComponent(updateData.eventDigitalisation3)}&` +
        `eventDigitalisation4=${encodeURIComponent(updateData.eventDigitalisation4)}&` +
        `eventDigitalisation5=${encodeURIComponent(updateData.eventDigitalisation5)}&` +
        `eventDigitalisationtotal=${encodeURIComponent(updateData.eventDigitalisationtotal)}&` +
        `delegateBoosting1=${encodeURIComponent(updateData.delegateBoosting1)}&` +
        `delegateBoosting2=${encodeURIComponent(updateData.delegateBoosting2)}&` +
        `delegateBoosting3=${encodeURIComponent(updateData.delegateBoosting3)}&` +
        `delegateBoosting4=${encodeURIComponent(updateData.delegateBoosting4)}&` +
        `delegateBoosting5=${encodeURIComponent(updateData.delegateBoosting5)}&` +
        `delegateBoostingtotal=${encodeURIComponent(updateData.delegateBoostingtotal)}&` +
        `speakersExpenses1=${encodeURIComponent(updateData.speakersExpenses1)}&` +
        `speakersExpenses2=${encodeURIComponent(updateData.speakersExpenses2)}&` +
        `speakersExpenses3=${encodeURIComponent(updateData.speakersExpenses3)}&` +
        `speakersExpenses4=${encodeURIComponent(updateData.speakersExpenses4)}&` +
        `speakersExpenses5=${encodeURIComponent(updateData.speakersExpenses5)}&` +
        `speakersExpensestotal=${encodeURIComponent(updateData.speakersExpensestotal)}&` +
        `technicalVisitMeeting1=${encodeURIComponent(updateData.technicalVisitMeeting1)}&` +
        `technicalVisitMeeting2=${encodeURIComponent(updateData.technicalVisitMeeting2)}&` +
        `technicalVisitMeeting3=${encodeURIComponent(updateData.technicalVisitMeeting3)}&` +
        `technicalVisitMeeting4=${encodeURIComponent(updateData.technicalVisitMeeting4)}&` +
        `technicalVisitMeeting5=${encodeURIComponent(updateData.technicalVisitMeeting5)}&` +
        `technicalVisitMeetingtotal=${encodeURIComponent(updateData.technicalVisitMeetingtotal)}&` +
        `culturalPerformance1=${encodeURIComponent(updateData.culturalPerformance1)}&` +
        `culturalPerformance2=${encodeURIComponent(updateData.culturalPerformance2)}&` +
        `culturalPerformance3=${encodeURIComponent(updateData.culturalPerformance3)}&` +
        `culturalPerformance4=${encodeURIComponent(updateData.culturalPerformance4)}&` +
        `culturalPerformance5=${encodeURIComponent(updateData.culturalPerformance5)}&` +
        `culturalPerformancetotal=${encodeURIComponent(updateData.culturalPerformancetotal)}

        

              `;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionHSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionHSection2(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionHSection2?` +
        `InsertedID=${InsertedID}&` +
        `venueSubsidy1=${encodeURIComponent(updateData.venueSubsidy1)}&` +
        `venueSubsidy2=${encodeURIComponent(updateData.venueSubsidy2)}&` +
        `venueSubsidy3=${encodeURIComponent(updateData.venueSubsidy3)}&` +
        `venueSubsidy4=${encodeURIComponent(updateData.venueSubsidy4)}&` +
        `venueSubsidy5=${encodeURIComponent(updateData.venueSubsidy5)}&` +
        `venueSubsidytotal=${encodeURIComponent(updateData.venueSubsidytotal)}&` +
        `professionalExhibitions1=${encodeURIComponent(updateData.professionalExhibitions1)}&` +
        `professionalExhibitions2=${encodeURIComponent(updateData.professionalExhibitions2)}&` +
        `professionalExhibitions3=${encodeURIComponent(updateData.professionalExhibitions3)}&` +
        `professionalExhibitions4=${encodeURIComponent(updateData.professionalExhibitions4)}&` +
        `professionalExhibitions5=${encodeURIComponent(updateData.professionalExhibitions5)}&` +
        `professionalExhibitionstotal=${encodeURIComponent(
          updateData.professionalExhibitionstotal
        )}&` +
        `pandemicSOPCompliance1=${encodeURIComponent(updateData.pandemicSOPCompliance1)}&` +
        `pandemicSOPCompliance2=${encodeURIComponent(updateData.pandemicSOPCompliance2)}&` +
        `pandemicSOPCompliance3=${encodeURIComponent(updateData.pandemicSOPCompliance3)}&` +
        `pandemicSOPCompliance4=${encodeURIComponent(updateData.pandemicSOPCompliance4)}&` +
        `pandemicSOPCompliance5=${encodeURIComponent(updateData.pandemicSOPCompliance5)}&` +
        `pandemicSOPCompliancetotal=${encodeURIComponent(updateData.pandemicSOPCompliancetotal)}&` +
        `taxesAndInsuranceSupport1=${encodeURIComponent(updateData.taxesAndInsuranceSupport1)}&` +
        `taxesAndInsuranceSupport2=${encodeURIComponent(updateData.taxesAndInsuranceSupport2)}&` +
        `taxesAndInsuranceSupport3=${encodeURIComponent(updateData.taxesAndInsuranceSupport3)}&` +
        `taxesAndInsuranceSupport4=${encodeURIComponent(updateData.taxesAndInsuranceSupport4)}&` +
        `taxesAndInsuranceSupport5=${encodeURIComponent(updateData.taxesAndInsuranceSupport5)}&` +
        `taxesAndInsuranceSupporttotal=${encodeURIComponent(
          updateData.taxesAndInsuranceSupporttotal
        )}&` +
        `eventEnhancement1=${encodeURIComponent(updateData.eventEnhancement1)}&` +
        `eventEnhancement2=${encodeURIComponent(updateData.eventEnhancement2)}&` +
        `eventEnhancement3=${encodeURIComponent(updateData.eventEnhancement3)}&` +
        `eventEnhancement4=${encodeURIComponent(updateData.eventEnhancement4)}&` +
        `eventEnhancement5=${encodeURIComponent(updateData.eventEnhancement5)}&` +
        `eventEnhancementtotal=${encodeURIComponent(updateData.eventEnhancementtotal)}&` +
        `photographyAndVideography1=${encodeURIComponent(updateData.photographyAndVideography1)}&` +
        `photographyAndVideography2=${encodeURIComponent(updateData.photographyAndVideography2)}&` +
        `photographyAndVideography3=${encodeURIComponent(updateData.photographyAndVideography3)}&` +
        `photographyAndVideography4=${encodeURIComponent(updateData.photographyAndVideography4)}&` +
        `photographyAndVideography5=${encodeURIComponent(updateData.photographyAndVideography5)}&` +
        `photographyAndVideographytotal=${encodeURIComponent(
          updateData.photographyAndVideographytotal
        )}

              `;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionHSection2Success(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFSectionHSection3(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFSectionHSection3?` +
        `InsertedID=${InsertedID}&` +
        `hybridEventSupport1=${encodeURIComponent(updateData.hybridEventSupport1)}&` +
        `hybridEventSupport2=${encodeURIComponent(updateData.hybridEventSupport2)}&` +
        `hybridEventSupport3=${encodeURIComponent(updateData.hybridEventSupport3)}&` +
        `hybridEventSupport4=${encodeURIComponent(updateData.hybridEventSupport4)}&` +
        `hybridEventSupport5=${encodeURIComponent(updateData.hybridEventSupport5)}&` +
        `hybridEventSupporttotal=${encodeURIComponent(updateData.hybridEventSupporttotal)}&` +
        `freightForwardingAndLogistic1=${encodeURIComponent(
          updateData.freightForwardingAndLogistic1
        )}&` +
        `freightForwardingAndLogistic2=${encodeURIComponent(
          updateData.freightForwardingAndLogistic2
        )}&` +
        `freightForwardingAndLogistic3=${encodeURIComponent(
          updateData.freightForwardingAndLogistic3
        )}&` +
        `freightForwardingAndLogistic4=${encodeURIComponent(
          updateData.freightForwardingAndLogistic4
        )}&` +
        `freightForwardingAndLogistic5=${encodeURIComponent(
          updateData.freightForwardingAndLogistic5
        )}&` +
        `freightForwardingAndLogistictotal=${encodeURIComponent(
          updateData.freightForwardingAndLogistictotal
        )}&` +
        `exhibitionBooths1=${encodeURIComponent(updateData.exhibitionBooths1)}&` +
        `exhibitionBooths2=${encodeURIComponent(updateData.exhibitionBooths2)}&` +
        `exhibitionBooths3=${encodeURIComponent(updateData.exhibitionBooths3)}&` +
        `exhibitionBooths4=${encodeURIComponent(updateData.exhibitionBooths4)}&` +
        `exhibitionBooths5=${encodeURIComponent(updateData.exhibitionBooths5)}&` +
        `exhibitionBoothstotal=${encodeURIComponent(updateData.exhibitionBoothstotal)}&` +
        `otherHostingCriteria1=${encodeURIComponent(updateData.otherHostingCriteria1)}&` +
        `otherHostingCriteria2=${encodeURIComponent(updateData.otherHostingCriteria2)}&` +
        `otherHostingCriteria3=${encodeURIComponent(updateData.otherHostingCriteria3)}&` +
        `otherHostingCriteria4=${encodeURIComponent(updateData.otherHostingCriteria4)}&` +
        `otherHostingCriteria5=${encodeURIComponent(updateData.otherHostingCriteria5)}&` +
        `otherHostingCriteriatotal=${encodeURIComponent(updateData.otherHostingCriteriatotal)}&` +
        `grandTotalAmountRequested1=${encodeURIComponent(updateData.grandTotalAmountRequested1)}&` +
        `grandTotalAmountRequested2=${encodeURIComponent(updateData.grandTotalAmountRequested2)}&` +
        `grandTotalAmountRequested3=${encodeURIComponent(updateData.grandTotalAmountRequested3)}&` +
        `grandTotalAmountRequested4=${encodeURIComponent(updateData.grandTotalAmountRequested4)}&` +
        `grandTotalAmountRequested5=${encodeURIComponent(updateData.grandTotalAmountRequested5)}&` +
        `grandTotalAmountRequestedtotal=${encodeURIComponent(
          updateData.grandTotalAmountRequestedtotal
        )}

              `;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFSectionHSection3Success(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFAcknowledgement(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFAcknowledgement?` +
        `InsertedID=${InsertedID}&` +
        `checklistDoc=${encodeURIComponent(updateData.checklistDoc)}&` +
        `acknowledgementIc=${encodeURIComponent(updateData.acknowledgementIc)}&` +
        `acknowledgementOrganistion=${encodeURIComponent(updateData.acknowledgementOrganistion)}&` +
        `acknowledgementDestination=${encodeURIComponent(updateData.acknowledgementDestination)}&` +
        `acknowledgementDate=${encodeURIComponent(updateData.acknowledgementDate)}
              `;
      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFAcknowledgementSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateCEFChecklist(updateData, InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl =
        `${SERVER_API}Admin_UpdateCEFChecklist?` +
        `InsertedID=${InsertedID}&` +
        `businessRegistrationCertificate=${encodeURIComponent(
          updateData.businessRegistrationCertificate
        )}&latestCompanyProfile=${encodeURIComponent(updateData.latestCompanyProfile)}&` +
        `letterofAppointment=${encodeURIComponent(updateData.letterofAppointment)}&` +
        `speakersList=${encodeURIComponent(updateData.speakersList)}&` +
        `eventBudget=${encodeURIComponent(updateData.eventBudget)}&` +
        `eventProgramme=${encodeURIComponent(updateData.eventProgramme)}&` +
        `letterofSupport=${encodeURIComponent(updateData.letterofSupport)}&` +
        `docummentForHomegrownEvents=${encodeURIComponent(updateData.docummentForHomegrownEvents)}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_UpdateCEFChecklistSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_DeleteEventByEventID(InsertedID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // Construct the request URL with all parameters from updateData
      const requestUrl = `${SERVER_API}Admin_DeleteEventByEventID?InsertedID=${InsertedID}`;

      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const updatedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      console.log(updatedIDAfterJSON, 'updatedIDAfterJSON In Backend');

      if (data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_DeleteEventByEventIDSuccess(updatedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function General_SelectPillars() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}General_SelectPillars`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.General_SelectPillarsSuccess(JSON.parse(data.ReturnData)));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function Admin_UpdateEventByExcel(updateDataArray, userID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      console.log('Admin_UpdateEventByExcel Payload', { userID, updateDataArray });

      const results = await Promise.all(
        updateDataArray.map(async (item) => {
          const response = await fetch(`${SERVER_API}Admin_UpdateEventByExcel`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userID,
              eventName: item.eventName,
              applicationName: item.applicationName,
              totalEconomicImpact: item.totalEconomicImpact,
              anticipatedDelegates: item.anticipatedDelegates,
              prefix: item.prefix,
              designation: item.designation,
              organisationName: item.organisationName,
              registeredOrganisationAddress: item.registeredOrganisationAddress,
              mailingAddress: item.mailingAddress,
              startDate: item.startDate,
              endDate: item.endDate,
              duration: item.duration,
              location: item.location,
              venue: item.venue,
              topic: item.topic,
              category: item.category,
              type: item.type,
              edition: item.edition,
              segment: item.segment,
              PCDS: item.PCDS,
              pillar: item.pillar,
              UNSDG: item.UNSDG,
              vie: item.vie,
              completion: item.completion,
              Status: item.Status,
              briefIntroduction: item.briefIntroduction,
              quarter: item.quarter,
              frequency: item.frequency,
              pattern: item.pattern,
              format: item.format,
              vision: item.vision,
              design: item.design,
              outcome: item.outcome,
              legacy: item.legacy,
              indicator: item.indicator,
              CreatedBy: item.CreatedBy,
            }),
          });

          const result = await response.json();
          console.log('result', result);

          if (Array.isArray(result)) {
            const parsed = JSON.parse(result[0].ReturnData)[0];
            if (result[0].ReturnVal === 1) {
              dispatch(slice.actions.Admin_UpdateEventByExcelSuccess(parsed.InsertedID));
            } else {
              dispatch(slice.actions.hasError(parsed.ReturnSqlError));
            }
          } else {
            dispatch(slice.actions.hasError(result.ReturnMsg || 'Unknown error'));
          }

          return result;
        })
      );

      console.log('All update results:', results);
    } catch (error) {
      console.log('error', error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function generateSummary(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}GenerateSummary?eventID=${id}`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.getSummarySuccess(JSON.parse(data.ReturnData)[0]));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function User_SelectGeneralScoreByEventID(eventID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${SERVER_API}User_SelectGeneralScoreByEventID?eventID=${encodeURIComponent(eventID)}`
      );
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          const eventData = JSON.parse(data.ReturnData)[0];
          dispatch(slice.actions.getAUser_SelectGeneralScoreByEventIDSuccess(eventData));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_Select_UNSDG_Target() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_Select_UNSDG_Target`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.AdminDashboard_Select_UNSDG_TargetSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AdminDashboard_AIAssistBox_GenerateSummaryByMonth() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}AdminDashboard_AIAssistBox_GenerateSummaryByMonth`);
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          dispatch(
            slice.actions.AdminDashboard_AIAssistBox_GenerateSummaryByMonthSuccess(JSON.parse(data.ReturnData))
          );
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}